var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseCryptoManager } from './base.js';
export class WebCryptoManager extends BaseCryptoManager {
    constructor(crypto) {
        super();
        /**
         * Generates a pair of `JsonWebKey`, both can be used to encrypt and decrypt data.
         * @returns a pair of `JsonWebKey`
         */
        this.generateKeyPair = () => __awaiter(this, void 0, void 0, function* () {
            const key = yield this.crypto.generateKey({
                name: 'RSA-OAEP',
                modulusLength: 2048,
                publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
                hash: { name: 'SHA-512' },
            }, true, ['encrypt', 'decrypt']);
            const privateKey = yield this.crypto.exportKey('jwk', key.privateKey);
            const publicKey = yield this.crypto.exportKey('jwk', key.publicKey);
            return { publicKey: JSON.stringify(publicKey), privateKey: JSON.stringify(privateKey) };
        });
        /**
         * Provides a way to encrypt data with `cryptoKey`.
         * @param cryptoKey - `JsonWebKey` generated by `generateKeyPair`
         * @param data - data to be encrypted
         * @returns encrypted data
         */
        this.encrypt = (cryptoKey, data) => __awaiter(this, void 0, void 0, function* () {
            if (typeof cryptoKey === 'string') {
                cryptoKey = JSON.parse(cryptoKey);
            }
            const encrypted = yield this.crypto.encrypt({
                name: 'RSA-OAEP',
            }, yield this.crypto.importKey('jwk', cryptoKey, { name: 'RSA-OAEP', hash: { name: 'SHA-512' } }, true, ['encrypt']), new TextEncoder().encode(data));
            return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
        });
        /**
         * Decrypts the encrypted data with `cryptoKey`.
         * @param cryptoKey - `JsonWebKey` generated by `generateKeyPair`
         * @param data - encrypted data
         * @returns decrypted data
         */
        this.decrypt = (cryptoKey, data) => __awaiter(this, void 0, void 0, function* () {
            if (typeof cryptoKey === 'string') {
                cryptoKey = JSON.parse(cryptoKey);
            }
            const decrypted = yield this.crypto.decrypt({
                name: 'RSA-OAEP',
            }, yield this.crypto.importKey('jwk', cryptoKey, { name: 'RSA-OAEP', hash: { name: 'SHA-512' } }, true, ['decrypt']), Uint8Array.from(atob(data), c => c.charCodeAt(0)));
            return new TextDecoder().decode(decrypted);
        });
        this.crypto = crypto;
    }
}
